import { NAMESPACE as GLOBAL_NAMESPACE } from '../../constants';
import constants from './constants';

const PREFIX = `${GLOBAL_NAMESPACE}/${constants.NAMESPACE}` as const;

const MOBILE_DEVICE_UPLOAD_TO_SD = `${PREFIX}/MOBILE_DEVICE_UPLOAD_TO_SD` as const;
const SEARCH_FILES_BY_NAME = `${PREFIX}/SEARCH_FILES_BY_NAME` as const;

export default {
  MOBILE_DEVICE_UPLOAD_TO_SD,
  SEARCH_FILES_BY_NAME,
};
